import { put, select, takeEvery } from "redux-saga/effects";

import { RuleAction } from "actions";

import { RuleSetAction } from "actions/ruleSets";

import { RULE_SET } from "constants/actionTypes";

import { getRuleSets } from "selectors";

function* onAddRuleToNewRuleSetAction(action) {
  const { ruleSetValues, ruleId } = action;
  yield put(RuleSetAction.create(ruleSetValues));
  yield put(
    RuleAction.update(
      { id: ruleId, rule_set_id: ruleSetValues.id, input_field: null },
      {
        changeReason: `Added Rule to ${ruleSetValues.name} Rule Set`,
      },
    ),
  );
}

function* onAddRulesToExistingRuleSetAction(action) {
  const { ruleIds, ruleSetId } = action;
  const state = yield select();
  const ruleSetByIdLookup = getRuleSets(state);
  const ruleSet = ruleSetByIdLookup[ruleSetId];

  for (const ruleId of ruleIds) {
    yield put(
      RuleAction.update(
        { id: ruleId, rule_set_id: ruleSetId, input_field: null },
        {
          changeReason: `Added Rule to Rule Set ${ruleSet.name}`,
          ruleIds,
        },
      ),
    );
  }
}

export default function* rootSaga() {
  yield takeEvery(
    RULE_SET.ADD_RULES_TO_EXISTING_RULE_SET.ACTION,
    onAddRulesToExistingRuleSetAction,
  );
  yield takeEvery(
    RULE_SET.ADD_RULE_TO_NEW_RULE_SET.ACTION,
    onAddRuleToNewRuleSetAction,
  );
}
